import React from 'react';
import './SocialMediaIcons.css';

const SOCIAL_LINKS = [
  {
    href: '',
    img: '/images/socialmedia.svg',
    alt: 'LinkedIn',
    label: 'LinkedIn',
  },
  {
    href: '',
    img: '/images/socialmedia1.svg',
    alt: 'Twitter',
    label: 'Twitter',
  },
  {
    href: '',
    img: '/images/socialmedia2.svg',
    alt: 'Facebook',
    label: 'Facebook',
  },
];

const SocialMediaIcons = ({ className = '' }) => (
  <div className={`social-icons ${className}`}>
    {SOCIAL_LINKS.map(({ href, img, alt, label }) => (
      <a
        key={label}
        href={href}
        className="social-icon"
        aria-label={label}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={img} alt={alt} className="social-media-icon" />
      </a>
    ))}
  </div>
);

export default SocialMediaIcons; 